// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { AvatarButtonGroup, ProficiencyDots } from 'src/design-system'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { avatarGroupProps } from 'app/packs/src/utils/user-helpers'
import { Collapsible } from 'components/atoms/collapsible'
import { observer } from 'mobx-react-lite'
import * as React from 'react'
import { store } from 'store/index'
import { UserWithProficiency } from '../table/data'
import { UserRow } from './user-row'

type ProficiencyLevelRowProps = {
  level: number
  users: UserWithProficiency[]
}

export const ProficiencyLevelRow: React.FC<ProficiencyLevelRowProps> = observer(
  ({ level, users }) => {
    const hasUsers = users.length > 0
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const storeUsers = users
      .map((u) => store.users.byId(u.userId))
      .filter((u) => u !== undefined)

    return (
      <div className="-mx-6 px-6 hover:bg-gray-50/50">
        <Collapsible
          triggerClassName="flex items-center justify-between pt-4 pb-2 w-full"
          className="data-[state=open]:mb-5"
          defaultOpen={false}
          label={
            <>
              <div className="flex items-center gap-7">
                <span className="text-base font-medium text-gray-900">
                  Proficiency Level
                </span>
                <ProficiencyDots level={level} />
              </div>
            </>
          }
        >
          {hasUsers && (
            <div className="pl-0">
              {users.map((user) => (
                <UserRow key={user.userId} userWithProficiency={user} />
              ))}
            </div>
          )}
        </Collapsible>
      </div>
    )
  }
)
